import Box from '@mui/material/Box';
import { ReactElement } from 'react';
import img1 from '../../../assets/img-2.jpg';
import payoff from '../../../assets/payoff-column.svg';
import { AppConfigurationOptions } from '../../../types';
import ApplicationTile from '../components/ApplicationTile';
import DecorativeTile from '../components/DecorativeTile';

export interface FiveTileGrid1Props {
  applications: [
    AppConfigurationOptions,
    AppConfigurationOptions,
    AppConfigurationOptions
  ];
}

export default function FiveTileGrid1({
  applications,
}: FiveTileGrid1Props): ReactElement {
  return (
    <Box
      sx={{
        minHeight: 1,
        width: 1,
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
        rowGap: { xs: 2, md: 5 },
        columnGap: { xs: 0, md: 5 },
        gridTemplateRows: {
          xs: 'repeat(3, minmax(300px, 1fr))',
          md: 'repeat(3, minmax(200px, 1fr))',
        },
        gridTemplateAreas: {
          xs: `"tile1"
               "tile4"
               "tile5"`,
          md: `"tile1 tile1 tile1 tile2"
               "tile3 tile3 tile4 tile4"
               "tile3 tile3 tile5 tile5"`,
        },
      }}
    >
      <ApplicationTile
        application={applications[0]}
        gridArea="tile1"
        variant="wide"
      />
      <DecorativeTile
        gridArea="tile2"
        index={1}
        image={img1}
        sx={{ display: { xs: 'none', md: 'flex' } }}
      />
      <DecorativeTile
        gridArea="tile3"
        index={2}
        image={payoff}
        sx={{
          backgroundSize: 'contain',
          backgroundOrigin: 'content-box',
          backgroundPosition: 'left bottom',
          padding: 5,
          display: { xs: 'none', md: 'flex' },
        }}
      />
      <ApplicationTile
        application={applications[1]}
        gridArea="tile4"
        variant="wide"
      />
      <ApplicationTile
        application={applications[2]}
        gridArea="tile5"
        variant="wide"
      />
    </Box>
  );
}
